import React from 'react';
import { Skeleton } from 'antd';
import styled from 'styled-components';

const SkeletonTable = styled.div`
  padding: 16px;
  background: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
`;

const EmailsLogsSkeleton = () => (
  <SkeletonTable>
    <Skeleton active paragraph={{ rows: 20 }} />
  </SkeletonTable>
);

export default EmailsLogsSkeleton; 